module.exports = __webpack_public_path__ + "img/egt.d8f07e3a.svg";